import { render, staticRenderFns } from "./push-photos-block.vue?vue&type=template&id=6152bcda&"
import script from "./push-photos-block.vue?vue&type=script&lang=js&"
export * from "./push-photos-block.vue?vue&type=script&lang=js&"
import style0 from "./push-photos-block.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
